import { render, staticRenderFns } from "./items-view.vue?vue&type=template&id=0c8676a8&"
import script from "./items-view.vue?vue&type=script&lang=js&"
export * from "./items-view.vue?vue&type=script&lang=js&"
import style0 from "./items-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports